// extracted by mini-css-extract-plugin
export default {"summaryMessages":"summaryMessages_c7nIS","summaryMessageItem":"summaryMessageItem_Onxqo"};